import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { useIsMobile } from '../services/UseIsMobile';

import '../css/pieResult.css';

const data = [
  { name: 'Part 1', value: 1 },
  { name: 'Part 2', value: 1 },
  { name: 'Part 3', value: 1 },
  { name: 'Part 4', value: 1 },
  { name: 'Part 5', value: 1 },
  { name: 'Part 6', value: 1 },
  { name: 'Part 7', value: 1 },
];

// Liste des couleurs pour chaque part
const COLORS = ['#6F3F89', '#375A9C', '#029FB2', '#29A648', '#E0B614', '#DA5E20', '#C11D24'];

const PieResultComponent = ({ currentQuestion , scoringValue, answers, from, onSliceClick }) => {
  const [rotationAngle, setRotationAngle] = useState(0);
  const [isFirstRender, setIsFirstRender] = useState(true); // État pour gérer le premier rendu

  // Calcul des valeurs sectionAngle et initialOffset après le premier rendu
  const sectionAngle = 360 / data.length; // Angle d'une section
  const initialOffset = 90 + sectionAngle / 2; // Alignement de la première section en haut

  useEffect(() => {
    // Calcul de l'angle de rotation basé sur la question actuelle
    const newAngle = initialOffset + ((currentQuestion - 1) * sectionAngle);
    setRotationAngle(newAngle);

    // Désactiver l'animation au premier rendu
    if (isFirstRender) {
      setIsFirstRender(false); // Le premier rendu est maintenant effectué
    }
  }, [currentQuestion, isFirstRender, sectionAngle, initialOffset]);

  const getImageForScore = (score) => {
    if (score <= -40) return '/Images/result0.png';
    else if (score <= -20) return '/Images/result1.png';
    else if (score <= 0) return '/Images/result2.png';
    else if (score <= 20) return '/Images/result3.png';
    else if (score <= 40) return '/Images/result4.png';
    return '/Images/result5.png';
  };
  const centerImage = getImageForScore(scoringValue);
  
  const getScaleForValue = (value) => {
    const minScale = 1;
    const maxScale = 1.5;
    const minValue = 1;
    const maxValue = 10;
    return minScale + (value - minValue) * ((maxScale - minScale) / (maxValue - minValue));
  };
  const isMobile = useIsMobile(768);
  const innerRadius = isMobile ? 40 : 65;
  const outerRadius = isMobile ? 70 : 100;
  const imgSize = isMobile ? 80 : 128;

  return (
    <div className={`pie-result-container ${from === "history" ? "pie-history-style" : "pie-result-style"}`}>
      {/* Conteneur rotatif */}
      <div
        className="pie-result-responsive"
        style={{
          transform: `rotate(-${rotationAngle}deg)`, // Rotation dans le sens antihoraire
          transition: isFirstRender ? 'none' : 'transform 1s ease-in-out', // Pas de transition pour le premier rendu, sinon animation
        }}
      >
        <div className="responsive-wrapper">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart animationDuration={0}>
              <Pie
                data={answers.map((v, i) => ({ name: `Part ${i + 1}`, value: Math.abs(v) })).reverse()}
                cx="50%"
                cy="50%"
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                paddingAngle={5}
                dataKey="value"
                isAnimationActive={true}
                animationDuration={1000}
              >
                {answers
                  .slice()        
                  .reverse()     
                  .map((val, index) => {
                  const scale = getScaleForValue(val);
                  return (
                    <Cell
                      className="pie-cell"
                      key={`cell-${index}`}
                      fill={COLORS[index]}
                      style={{
                        transform: `scale(${scale})`,
                        transformOrigin: "center",
                        transition: "transform 0.05s linear",
                        cursor: "pointer"
                      }}
                      tabIndex={-1}
                      onClick={() => {
                          if (onSliceClick) onSliceClick(COLORS.length - index - 1, val);
                        }}
                    />
                  );
                })}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Texte centré */}
      <div className="centered-result-text">
        <img
          src={centerImage}
          alt="Scoring Result"
          style={{
            width: `${imgSize}px`,
            height: `${imgSize}px`,
          }}
        /></div>
    </div>
  );
};

export default PieResultComponent;
